import { takeEvery } from 'redux-saga/effects';
import { GET_APP_UPDATE_DETAILS, UPDATE_DETAILS } from './app-update.action';
import { getAppUpdateDetailsSaga, updateDetailsSaga } from './app-update.saga';
import { promisifySaga } from '../promisifySaga';

export const AppUpdateSaga = [
  takeEvery(GET_APP_UPDATE_DETAILS, getAppUpdateDetailsSaga),
  takeEvery(UPDATE_DETAILS, promisifySaga(updateDetailsSaga)),
];
